export const TONE_ESTILO = [
  { value: '', label: '— Selecione —' },
  { value: 'vendedor', label: 'Vendedor' },
  { value: 'sdr', label: 'SDR' },
  { value: 'sac', label: 'SAC' },
  { value: 'informacional', label: 'Informacional' },
  { value: 'suporte_tecnico', label: 'Suporte técnico' }
];

export const TONE_TOM = [
  { value: '', label: '— Selecione —' },
  { value: 'descontraído', label: 'Descontraído' },
  { value: 'formal', label: 'Formal' },
  { value: 'animado', label: 'Animado' },
  { value: 'profissional', label: 'Profissional' },
  { value: 'acolhedor', label: 'Acolhedor / caloroso' },
  { value: 'entusiasmado', label: 'Entusiasmado' },
  { value: 'calmo', label: 'Calmo / tranquilo' },
  { value: 'confiante', label: 'Confiante' },
  { value: 'didático', label: 'Didático' },
  { value: 'empático', label: 'Empático' },
  { value: 'neutro', label: 'Neutro' },
  { value: 'persuasivo', label: 'Persuasivo' },
  { value: 'autoritativo', label: 'Autoritativo' }
];

export const TONE_EMOJIS = [
  { value: '', label: '— Selecione —' },
  { value: 'nunca', label: 'Nunca' },
  { value: 'com_moderacao', label: 'Com moderação' }
];

export const TONE_LINGUAGEM = [
  { value: '', label: '— Selecione —' },
  { value: 'formal', label: 'Formal' },
  { value: 'informal', label: 'Informal' },
  { value: 'técnico', label: 'Técnico' },
  { value: 'profissional', label: 'Profissional' },
  { value: 'cordial', label: 'Cordial / educado' },
  { value: 'coloquial', label: 'Coloquial' },
  { value: 'acessível', label: 'Acessível / simples' },
  { value: 'institucional', label: 'Institucional' },
  { value: 'direto', label: 'Direto / objetivo' },
  { value: 'empático', label: 'Empático' },
  { value: 'acadêmico', label: 'Acadêmico' }
];

export const TIER_OPTIONS = [
  { value: 'basico', label: 'Basic' },
  { value: 'intermediario', label: 'Smart' },
  { value: 'avancado', label: 'Bolt' }
];

export const TIER_DESCRIPTION = {
  basico: 'Respostas rápidas, ideal para FAQ e dúvidas simples.',
  intermediario: 'Equilíbrio entre velocidade e profundidade, para conversas mais elaboradas.',
  avancado: 'Máxima precisão e memória estruturada, ideal para bases grandes e respostas técnicas.'
};

export function defaultTone() {
  return {
    estilo: '',
    tom: '',
    emojis: '',
    temperatura: 0.7,
    tipoLinguagem: ''
  };
}

export const MEDIA_TYPE_OPTIONS = [
  { value: 'image', label: 'Imagem' },
  { value: 'gif', label: 'GIF' },
  { value: 'pdf', label: 'PDF' },
  { value: 'link', label: 'Link externo' }
];

export const CTA_SIZE_OPTIONS = [
  { value: 'pequeno', label: 'Pequeno' },
  { value: 'medio', label: 'Médio' },
  { value: 'grande', label: 'Grande' }
];

export const CTA_CONVERSION_OPTIONS = [
  { value: 'none', label: 'Sem conversão' },
  { value: 'add_to_cart', label: 'AddToCart' },
  { value: 'lead', label: 'Lead (confirmar dados)' }
];

export const TRAIN_AGENT_LOOM_VIDEO_IDS = [
  '73cc98cecc7347809f8ff790c906acd3',
  'bdaaf1869a4c4d0fa3a47a358105e41e',
  '4496a94823464f4d8a1f6f3412942dcb',
  'f8dea0ac948d4240a102ee3b3b6740fe',
  '4c8466640e454b8587f1f7a54255bd98',
  '4c26a213cecc4ea7800d2988ad0cf18c',
  '26b2a7f39ccc4044b450487ef6ef4789'
];
